module.exports = __webpack_public_path__ + "img/页头logo.0d36b7b4.png";